import $ from 'cash-dom';
import UrlHelper from './UrlHelper';

class Utils {
	static sub5Value = null;
	static _hasVendorsListCarousel = null;
	static _$vendorsListCarousel = null;
	static _cookiesChosenVariation = null;

	/**
	 * Implementation of lodash.get function
	 * @param object {Object|Array}
	 * @param keys {string}
	 * @param defaultVal {*}
	 * @returns {*}
	 */
	static get(object, keys, defaultVal) {
		keys = Array.isArray(keys) ? keys : keys.split('.');
		object = object[keys[0]];

		if (object && keys.length > 1) {
			return this.get(object, keys.slice(1), defaultVal);
		}

		return object === undefined ? defaultVal : object;
	}

	/**
	 * Maps InputField value field to DropdownField's value in case if dropdown has options with ranges,
	 * e.g. under-100k, 100k-200k, over-200K. It's your responsibility to pass proper dropdown optionsValues.
	 * @param {number} rangeInputValue
	 * @param {string[]} optionsValues
	 * @return {string|null} Returns DropdownFiled value.
	 */
	static mapInputToRangeDropdownValue(rangeInputValue, optionsValues) {
		if (!Array.isArray(optionsValues)) {
			return null;
		}

		for (const optionValue of optionsValues) {
			if (!optionValue) {
				continue;
			}

			const [min, max] = this._getMinMaxFromOptionValue(optionValue);

			if (rangeInputValue >= min && rangeInputValue < max) {
				return optionValue;
			}
		}
	}

	static _getMinMaxFromOptionValue(optionValue) {
		let min;
		let max;

		if (optionValue.startsWith('under')) {
			min = 0;
			optionValue = optionValue.replace('under-', '');
		}

		if (optionValue.startsWith('over')) {
			max = Infinity;
			optionValue = optionValue.replace('over-', '');
		}

		const multiply = optionValue.includes('k') ? 1000 : 1;
		optionValue = optionValue.replaceAll('k', '');

		if (min === 0) {
			max = +optionValue;
		} else if (max === Infinity) {
			min = +optionValue;
		} else {
			[min, max] = optionValue.split('-');
		}

		min = min !== 0 ? min * multiply : min;
		max = max !== Infinity ? max * multiply : max;

		return [min, max];
	}

	/**
	 * Gets input value, gets raw value of the Clever, if clever is set to the input (via customObjectCleave property),
	 * or regular input value.
	 * @param $input
	 * @return {*|string|jQuery|null}
	 */
	static getCleaverOrRegularValue($input) {
		$input = $($input);

		if (!$input.length) {
			return null;
		}

		const clever = $input.get(0).customObjectCleave;
		const val = clever ? clever.getRawValue() : $input.val();

		return val;
	}

	/**
	 * Sets Clever raw value, if clever is set to the input (via customObjectCleave property),
	 * or sets regular input value.
	 * @param $input
	 * @param value
	 * @return {null}
	 */
	static setCleaverOrRegularValue($input, value) {
		$input = $($input);

		if (!$input.length) {
			return null;
		}

		const clever = $input.get(0).customObjectCleave;

		if (clever) {
			clever.setRawValue(value);
		} else {
			$input.val(value);
		}
	}

	static getCookie(name) {
		let matches = document.cookie.match(new RegExp(
			'(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
		));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	static setCookie(name, value, options = {}) {
		options = {
			path: '/',
			// add other defaults here if necessary
			...options
		};

		if (options.expires instanceof Date) {
			options.expires = options.expires.toUTCString();
		}

		let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

		for (let optionKey in options) {
			updatedCookie += '; ' + optionKey;
			let optionValue = options[optionKey];
			if (optionValue !== true) {
				updatedCookie += '=' + optionValue;
			}
		}

		document.cookie = updatedCookie;
	}


	static deleteCookie(name) {
		Utils.setCookie(name, '', {
			'max-age': -1
		})
	}

	static addHardcodedSubIdToLinks(value, vendorId = null, htmlElement = null) {
		let links = htmlElement ? htmlElement.find('a, [data-href]') : $('a, [data-href]');

		this.sub5Value = value;

		links.each((i, el) => {
			const $el = $(el);
			const hrefAttr = $el.is('[href]') ? 'href' : 'data-href';
			const href = $el.attr(hrefAttr);
			const regex = vendorId ? new RegExp(`/go/vendor/(.*)(${vendorId})/`) : /\/go\/vendor\/(.*)(\d+)\//;

			if (regex.test(href)) {
				let newHref = Utils.addSub5ToLink(href, value),
					filterDeeplinks = $el.data('filter-deeplinks'),
					originalHref = $el.data('original-href');

				$el.attr(hrefAttr, newHref);

				if (filterDeeplinks) {
					for (const deeplink in filterDeeplinks) {
						filterDeeplinks[deeplink] = Utils.addSub5ToLink(filterDeeplinks[deeplink], value);
					}

					$el.data('filter-deeplinks', filterDeeplinks);
				}

				if (originalHref) {
					$el.data('original-href', Utils.addSub5ToLink(originalHref, value));
				}
			}
		});

		if (htmlElement) {
			return htmlElement;
		}
	}

	static addSub5ToLink(link, value) {
		if (link.indexOf('sub5') === -1) {
			if (link.indexOf("?") === -1) {
				link += "?";
			} else {
				link += "&";
			}

			link += 'sub5' + "=" + value;
		} else {
			const regex = /([?&])sub5=([^&]*)/;
			link = link.replace(regex, '$1sub5=' + value);
		}

		return link;
	}

	static setFilteredDeeplinkFamilyForAllLinksOfVendor(deeplinkFamily, vendorId, $htmlElement = null) {
		const $links = $htmlElement ? $htmlElement.find('a, [data-href]') : $('a, [data-href]');

		$links.each((i, link) => {
			const $link = $(link);
			const {hrefAttr, href} = this._getHrefAttrAndHref($link);

			if (UrlHelper.isGoVendor(href, vendorId)) {
				const {newUrl, originalDeeplinkFamily} = UrlHelper.replaceDeeplinkFamily(href, deeplinkFamily, vendorId);

				$link.attr(hrefAttr, newUrl);

				if ($link.data('original-deeplink-family') === undefined) {
					$link.data('original-deeplink-family', originalDeeplinkFamily);
					$link.data('vendor-id', vendorId);
				}

				if (deeplinkFamily !== null && deeplinkFamily !== undefined) {
					$link.data('deeplink-family', deeplinkFamily);
				}

				Alooma.applyAloomaTrackingParamsToLink(link);
			}
		});
	}

	static setOriginalDeeplinkIfNeededForAllLinks($htmlElement = null) {
		const $links = $htmlElement ? $htmlElement.find('a, [data-href]') : $('a, [data-href]');

		$links.each((i, link) => {
			const $link = $(link);
			const {hrefAttr, href} = this._getHrefAttrAndHref($link);
			const vendorId = $link.data('vendor-id');

			if (vendorId && UrlHelper.isGoVendor(href, vendorId)) {
				const originalDeeplinkFamily = $link.data('original-deeplink-family');

				if (originalDeeplinkFamily !== undefined && originalDeeplinkFamily !== null) {
					const {newUrl} = UrlHelper.replaceDeeplinkFamily(href, originalDeeplinkFamily, vendorId);
					$link.attr(hrefAttr, newUrl);
					Alooma.applyAloomaTrackingParamsToLink(link);
				}
			}
		});
	}

	static _getHrefAttrAndHref($link) {
		const hrefAttr = $link.is('[href]') ? 'href' : 'data-href';
		const href = $link.attr(hrefAttr);

		return {hrefAttr, href};
	}

	/**
	 * @return {boolean}
	 */
	static getHasVendorsListCarousel() {
		if (this._hasVendorsListCarousel === null) {
			this._hasVendorsListCarousel = !!this.getVendorsCarouselElement().length;
		}

		return this._hasVendorsListCarousel;
	}

	static getVendorsCarouselElement() {
		if (this._$vendorsListCarousel === null) {
			this._$vendorsListCarousel = $('#vendors-list-splide-carousel');
		}

		return this._$vendorsListCarousel;
	}

	static getCookiesChosenVariation() {
		if (this._cookiesChosenVariation === null) {
			const cookies = document.cookie.split('; ');
			const postId = $('body').data('post-id');
			const neededKey = 'chosen_variation_' + postId + '_' + postId;

			for (const cookie of cookies) {
				const [cookieKey, cookieValue] = cookie.split('=');

				if (cookieKey === neededKey) {
					this._cookiesChosenVariation = cookieValue;
					break;
				}
			}
		}

		return this._cookiesChosenVariation;
	}

	static async setTimeout(timeout) {
		return new Promise(resolve => setTimeout(resolve, timeout));
	}

	/**
	 * Adds a GET parameter to a URL
	 * @param {string} url - The URL to add the parameter to
	 * @param {string} paramName - The name of the parameter
	 * @param {string} paramValue - The value of the parameter
	 * @return {string} The URL with the added parameter
	 */
	static addGetParameter(url, paramName, paramValue) {
		const separator = url.indexOf('?') === -1 ? '?' : '&';
		return url + separator + encodeURIComponent(paramName) + '=' + encodeURIComponent(paramValue);
	}
}

export default Utils;
